<template>
	<div>
	<div class="panel-close" v-on:click="ClosePanel"></div>
		<div class="menu">
			<nav>
				<ul>
					<li v-on:click="goTo('home')"><img src="../assets/menu/home.png" alt=""></li>
					<li v-on:click="goTo('galerie')"><img src="../assets/menu/galerie.png" alt=""></li>
					<li v-on:click="OpenCloseMetier" ><img src="../assets/menu/metier.png" alt=""></li>
					<li v-on:click="OpenCloseContact"><img src="../assets/menu/contact.png" alt=""></li>
				</ul>
			</nav>
		</div>

		<div class="contact-panel panel-right-menu" id="metier"> 

				<div class="header">
					<img src="../assets/logo-vinzi-fin.png" height="120" alt="">
				</div>
				<div class="bloc-info">
					<img src="../assets/picto_film.png" alt="">
					<h3>PRODUCTION & RéALISATION DE FILMS</h3>
				</div>
				<div class="bloc-info">
					<img src="../assets/picto_drone.png" alt="">
					<h3>TOURNAGE DRONE</h3>
				</div>
				<div class="bloc-info">
					<img src="../assets/picto_vr360.png" alt="">
					<h3>VIDéOS 360° VR</h3>
				</div>	
				<div class="bloc-info">
					<img src="../assets/picto_live.png" alt="">
					<h3>LIVE STREAMING &nbsp;(YOUTUBE & FACEBOOK)</h3>
				</div>
		</div>

		<div class="contact-panel panel-right-menu" id="contact"> 

				<div class="header">
					<img src="../assets/logo-vinzi-fin.png" height="120" alt="">
				</div>
				<div class="bloc-info">
					<img src="../assets/picto_adresse.png" alt="">
					<h3>1, place Francis Chirat <br> 13002 Marseille</h3>
				</div>
				<div class="bloc-info">
					<img src="../assets/picto_contact.png" alt="">
					<h3>
						<a href="tel:0615037617">06 15 03 76 17</a>
						<br>
						<a href="mailto:contact@vinzi-studio.com">contact@vinzi-studio.com</a>  
					</h3>
				</div>
		</div>
	</div>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'Menu',
  methods: {
  	ClosePanel() {
  		if ($('#metier').css('right') == "0px" || $('#contact').css('right') == "0px") {
  			
  			$('.panel-right-menu').css('right', "-100%");
  			$('.panel-close').css('left', "-100%");

  		}
  	},
  	OpenCloseMetier() {
  		if ($('#metier').css('right') != "0px") {
  			$('.panel-right-menu').css('right', "-100%");

  			$('#metier').css('right', 0);
  			$('.panel-close').css('left', 0);

  		}else {
  			$('#metier').css('right', "-100%");
  			$('.panel-close').css('left', "-100%");

  		}
  	},
  	OpenCloseContact() {
  		if ($('#contact').css('right') != "0px") {
  			$('.panel-right-menu').css('right', "-100%");

  			$('#contact').css('right', 0);
  			$('.panel-close').css('left', 0);

  		}else {
  			$('#contact').css('right', "-100%");
  			$('.panel-close').css('left', "-100%");

  		}
  	},
  	goTo(page) {
  		var offset = 0
  		if (page == 'galerie') { offset = $(window).height() }
  			this.ClosePanel()
  		$('html, body').animate({
			scrollTop: offset
		}, 'slow');
  	}
  }
}
</script>

<style scoped>
.menu {
	width: 20px;
	padding: 0 15px;
	height: 100vh;
	background: rgba(0,0,0,0.5);
	position: fixed;
	right: 0;
	top: 0;
	bottom: 0;
	z-index: 110;
}

.menu nav li:hover img { 
	opacity: 0.7;	
}
.menu nav li img {
	transition-duration: .5s;
}

.menu nav li { 
	list-style: none; 
	display: block;
	text-align: center;
	padding: 15px 0;
	border-bottom: 1px solid #ddd;
	cursor: pointer;
	transition-duration: .5s;
}



.panel-close {
  position: fixed;
  top: 0;
  min-height: 100%;
  height: auto;
  width: 50%;
  z-index: 88;
  left: -50%;
}
.panel-right-menu {
  position: fixed;
  top: 0;
  right: -100%;
  min-height: 100%;
  height: 100%;
  overflow-y: auto;
  background: rgba(0,0,0,0.7);
  color: #fff;
  text-align: left;
  width: 40%;
  padding: 0% 5%;
  transition-duration: .5s;
  z-index: 99;

}

.header {
	text-align: center;
	padding: 10% 0 10%;
}

.bloc-info  {
	display: block;
	margin-bottom: 30px;
}

.bloc-info img  {
	display: inline-block;

}
.bloc-info h3:after {
	content: "";
	display: block;
	width: 100px;
	height: 1.5px;
	background: #fff;
	margin: 15px 0;

}
.bloc-info h3 {
	font-weight: 100;
	text-transform: uppercase;
	margin: 20px 0 0 20px;
	display: inline-block;
}

#contact h3 {
	text-transform: initial;
}
 


@media screen and (max-width: 640px) { 

  .panel-right-menu {
    width: 80%;
    padding: 10%;
    right: -100%;
    text-align: center;
  } 

	.content {
		position: relative;
		top: 0%;
		left: 00%;
		transform: translateX(0) translateY(0);
		width: 100%;
		overflow-y: scroll;
	} 

  .panel-right-menu img {
  	display: block;
	margin: auto;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Menu.vue